import styled from 'styled-components'

const Divider = styled.div`
  width: 100%;
  margin: 20px 0 20px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
`

export default Divider
